import { defineComponent as _defineComponent } from 'vue'
interface IProps {
  text?: string;
  textTooltip?: string;
  typeButtom?: string;
}

interface IEmits {
  (event: 'click', e: MouseEvent): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomChip',
  props: {
    text: null,
    textTooltip: null,
    typeButtom: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click', e: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emit }
}

})